import getFilterChips from './getFilterChips';
export * from './getFilterChips';
export default getFilterChips;
